import React, { useEffect } from 'react'
import { useDataChange, useDataValue } from 'Simple/Data.js'
import View from './view.js'

export default function Logic(props) {
  let change = useDataChange({
    context: 'sort',
    path: 'selected',
    viewPath: props.viewPath,
  })

  let selected = useDataValue({
    context: 'sort',
    path: 'selected',
    viewPath: props.viewPath,
  })

  useEffect(() => {
    if (props.onRegisterClearSort) {
      let clearFn = () => {
        change({
          ...Object.fromEntries(Object.keys(selected).map(key => [key, null])),
        })
      }

      props.onRegisterClearSort(props.stageId, clearFn)
    }
  }, [props.onRegisterClearSort, props.stageId])

  return <View {...props} />
}
